import { ActivityBookingTypesEnum } from '../generated/graphql';

export type ActivityState = 'SOLD_OUT' | 'AVAILABLE' | 'UNAVAILABLE' | 'EXTERAL';

export interface PartialActivityHitFragment {
    bookingType: ActivityBookingTypesEnum;
    timeslots: Array<{ allotment?: number | null }>;
}

const getActivityState = (hit: PartialActivityHitFragment): ActivityState => {
    const { timeslots } = hit;

    const canBuy =
        timeslots.length > 0 &&
        timeslots.some(timeslot =>
            canBuyTickets(
                hit.bookingType === ActivityBookingTypesEnum.Direct,
                hit.bookingType === ActivityBookingTypesEnum.External,
                timeslot.allotment ?? undefined
            )
        );
    if (canBuy && timeslots.some(timeslot => timeslot.allotment !== 0)) {
        return 'AVAILABLE';
    }

    if (
        hit.bookingType === ActivityBookingTypesEnum.External ||
        hit.bookingType === ActivityBookingTypesEnum.NotBookable
    ) {
        return 'EXTERAL';
    }
    if (hit.bookingType === ActivityBookingTypesEnum.Direct && timeslots.every(timeslot => timeslot.allotment === 0)) {
        return 'SOLD_OUT';
    }

    return 'UNAVAILABLE';
};

export function canBuyTickets(hasOnlineSale: boolean, hasOfflineSale: boolean, allotment?: number): boolean {
    const hasAllotment = allotment !== 0; // undefined means "infinite" allotment
    // when there's offline sale, you can always buy offline. when there is online sale there needs to be positive allotment
    return (hasOnlineSale && hasAllotment) || hasOfflineSale;
}

export default getActivityState;
